import styled from 'styled-components';
import { COLORS, FONTS } from '@stelecom/ui-react/assets/js/constants';
import GridContainer from '@stelecom/ui-react/components/layouts/gridContainer';
import {
  FlexBoxCol,
  FlexBoxRow,
} from '@stelecom/ui-react/components/layouts/flexBoxGrid';
import { BaseButton } from '@stelecom/ui-react/components/buttons/baseButton';
import { breakpoints } from '~/src/components/Header/styled';

export const MenuItem = styled.div<{ withButton?: boolean }>`
  position: relative;
  display: flex;
  height: 100%;
  align-self: center;
  white-space: nowrap;
  font-size: 16px;
  line-height: 22px;

  &:first-child {
    padding-left: 20px;
  }

  &:not(:first-child) {
    padding-left: 20px;
  }

  &:not(:last-child) {
    padding-right: 20px;
  }

  & > a {
    color: ${COLORS.PINK_BRIGHT};
    font-size: 16px;
    line-height: 22px;
    font-style: normal;
    font-weight: normal;
    padding-top: 16px;
    padding-bottom: 16px;
    position: relative;
    margin: auto 0;

    @media (max-width: 1440px){
      font-size: 14px;
    }

    &:after {
      position: absolute;
      left: 0;
      width: 0;
      height: 4px;
      bottom: -10px;
      background: ${COLORS.white};
      transition: all 0.2s ease;
      opacity: 0;
      z-index: 10;
    }
  }

  &:hover {
    & > a {
      &:after {
        width: 100%;
        opacity: 1;
      }
      & + div > div {
        opacity: 1;
      }
    }
    & > div {
      opacity: 1;
      visibility: visible;
      transform: scaleY(1);
    }
  }
`;

export const CollapsedMenu = styled.div<{ isVisibility: boolean }>`
  position: fixed;
  left: 0;
  right: 0;
  top: ${(p) => (p.isVisibility ? '112px' : '72px')};
  flex-wrap: nowrap;
  align-items: center;
  background: ${COLORS.lightGrey};
  opacity: 0;
  padding: 0 90px;
  visibility: hidden;
  transform-origin: top center;
  transform: scaleY(0);
  transition: transform 0.3s linear, opacity 0.3s linear, visibility 0.3s linear;
  overflow: hidden;
  box-shadow: 0 8px 20px -2px rgba(41, 44, 48, 0.1);
  z-index: 7;
`;

export const CollapsedWrapper = styled(GridContainer)`
  opacity: 0;
  display: block;
  margin-top: 48px;
  margin-bottom: 48px;
  transition: opacity 0.1s linear;

  @media (max-width: ${breakpoints.desktop}) {
    width: 100%;
    max-width: 1360px;
    padding: 0;
  }
`;

export const Row = styled(FlexBoxRow)``;

export const Col = styled(FlexBoxCol)``;

export const MenuTitle = styled.div`
  color: ${COLORS.black};
  margin-bottom: 8px;
  ${FONTS.XS};
`;

export const MenuDescription = styled.div`
  color: ${COLORS.darkGrey};
  margin-bottom: 24px;
  ${FONTS.XS};
  white-space: pre-wrap;
`;

export const Button = styled(BaseButton)`
  width: fit-content;
`;

export const MenuItemsRow = styled(FlexBoxRow)`
  flex-direction: column;
  max-height: 200px;
  ${FONTS.XS};
`;

export const ChildMenuItem = styled.a`
  display: inline-block;
  margin-bottom: 20px;
  ${FONTS.Medium};
  color: ${COLORS.black};
  transition: color 0.3s ease;
  white-space: pre-wrap;

  &:hover {
    color: ${COLORS.red};
  }
`;
